/* Country flag as an <img> from flagcdn — Windows can't render flag emoji.
 * Mirrors the prototype's flagImg()/iso2()/NAME2CC helpers; accepts either an
 * ISO-ish country code (`cc`, e.g. a city's cc) or a country name. Styling comes
 * from the `.flag` class declared in each screen's scoped stylesheet. */
import { COUNTRIES } from '@venturewrist/engine';

const NAME2CC: Record<string, string> = (() => {
  const m: Record<string, string> = {};
  for (const c of COUNTRIES as Array<{ name: string; id: string }>) m[c.name] = c.id;
  m['Hungary'] = 'hu';
  return m;
})();
const ISO2_FIX: Record<string, string> = { uk: 'gb', idn: 'id', sau: 'sa' };
const iso2 = (cc: string) => { cc = String(cc || '').toLowerCase(); return ISO2_FIX[cc] || cc; };

export function Flag({ cc, country }: { cc?: string; country?: string }) {
  const code = iso2(cc || (country ? NAME2CC[country] : '') || '');
  if (!code) return null;
  return (
    <img className="flag" src={`https://flagcdn.com/${code}.svg`} alt={country || code} title={country || ''} loading="lazy"
      onError={(e) => { (e.currentTarget as HTMLImageElement).replaceWith(document.createTextNode(code.toUpperCase() + ' ')); }} />
  );
}
